import React, { useEffect, useCallback, useState } from 'react';
import { Redirect } from 'react-router-dom';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import {
	colors, Button, TextField, Typography,
	Grid, Select, Card, CardHeader, CardContent,
	Divider, Accordion, AccordionSummary, Checkbox,
	AccordionDetails, FormControlLabel, Tabs, Tab
} from '@material-ui/core';
import { Page, Header, Map, SelectField, Label, SearchBar, FiltersDrawer } from 'components';
import {
	SetFormState, GetAlgorithmsCities
} from '../actions/AlgorithmsActions';
import Overshooting from './components/Overshooting';
import CrossedSectors from './components/CrossedSectors';
import CoverageHoles from './components/CoverageHoles';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	}
}));

const tabs = [
	{ value: 'overshooting', label: 'Overshooting' },
	{ value: 'crossedSectors', label: 'Crossed Sectors' },
	{ value: 'coverageHoles', label: 'Coverage Holes' },
];

const Algorithms = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.algorithmsReducer.formState);
	const algoFilePath = useSelector((state) => state.algorithmsReducer.algoFilePath);
	const [tab, setTab] = useState('overshooting');

	const userId = useSelector(state => state.session.user.id);

	const _getData = useCallback(() => {
		dispatch(GetAlgorithmsCities(userId));
	}, []);

	useEffect(() => {
		_getData();
	}, [_getData]);

	const handleTabsChange = (event, value) => {
		setTab(value);
	};

	if (!tab) {
		return <Redirect to="/home" />;
	}

	if (!tabs.find((t) => t.value === tab)) {
		return <Redirect to="/errors/error-404" />;
	}

	return (
		<Page className={classes.root} title="Algorithms">
			<Header module="Modules" view="Algorithms" />
			<Tabs
				className={classes.tabs}
				onChange={handleTabsChange}
				scrollButtons="auto"
				value={tab}
				variant="scrollable"
			>
				{tabs.map((t) => (
					<Tab key={t.value} label={t.label} value={t.value} />
				))}
			</Tabs>
			<Divider className={classes.divider} />
			<div className={classes.content}>
				{tab === 'overshooting' && <Overshooting />}
				{tab === 'crossedSectors' && <CrossedSectors />}
				{tab === 'coverageHoles' && <CoverageHoles />}
			</div>
		</Page>
		// <Page className={classes.root} title="Algorithms">
		// 	<div className={clsx(classes.container)}>
		// 		<Grid container spacing={1}>
		// 			<Grid item md={12} xs={12}>
		// 				<AlgorithmsHeader />
		// 			</Grid>
		// 		</Grid>
		// 		<Grid container spacing={1}>
		// 			<Grid item md={12} xs={12}>
		// 			</Grid>
		// 		</Grid>
		// 	</div>
		// </Page>
	);
};

export default Algorithms;
